const questions = document.querySelectorAll('.faq-question__question');

if(questions) {
    [...questions].forEach((q) => {
        q.setAttribute('id', convertString(q.innerHTML))
    })

    faqAnchor();

    window.addEventListener('popstate', (e) => {
        faqAnchor();
    })
}

function faqAnchor () {
    const questions = document.querySelectorAll('.faq-question__question');

    let currentUrl = document.URL;
    let urlParts   = currentUrl.split('#');

    [...questions].forEach((q) => {
        if(urlParts[1] == q.id) {
            q.parentNode.parentNode.setAttribute('open', 'open')
        }
    })
}

function convertString(string) {
    var str = string.toLowerCase();
    var charMap = {
     'ä': 'ae',
     'ö': 'oe',
     'ü': 'ue',
     'ß': 'ss',
     'æ': 'ae',
     'ø': 'oe',
     'å': 'aa',
     'á': 'a',
     'ú': 'u',
     'ó': 'o',
     'é': 'e',
     'í': 'i',
     'ñ': 'n',
     'č': 'c',
     'ď': 'd',
     'ě': 'e',
     'ň': 'n',
     'ř': 'r',
     'š': 's',
     'ť': 't',
     'ů': 'u',
     'ý': 'y',
     'ž': 'z',
     'ű': 'ue',
     'ő': 'oe',
     '?': '',
     ',': '',
     '.': '',
     '\'': '',
     '"': '',
     '“': '',
     '”': '',
     '`': '',
     '´': '',
     '!': '',
     '_': '',
     '%': '--',
    };

    var  globalModifier= /(ä|ö|ü|ß|æ|ø|å|á|ú|ó|é|í|ñ|á|č|ď|é|ě|í|ň|ó|ř|š|ť|ú|ů|ý|ž|ű|ő|\?|\,|\.|\'|"|“|”|`|´|!|_|%)/g;

    if (globalModifier.test(str)) {
     str = str.replace(globalModifier, function(m, key, index) {
      return charMap[key];
     });
    }

    str = str.replace(/ /g, '-')
    str = str.replace(/&nbsp;\s*$/, '');
    str = str.replace(/[^a-z0-9áéíóúñü \.,_-]/gim, '-')
    str =  str.replace(/-sup----sup-/g, '')
    str = str.replace('--', '%')
    str = str.replace(/-\s*$/, '');

    return str;
}
